import React from 'react';
import {
  HiddenCheckbox,
  StyledCheckbox,
  StyledCheckboxContainer,
  StyledCheckboxLabel,
} from '../styles/FilterCheckBox.styles';
import { capitalizeFirstWordOfSentence } from '../../../../../../../utils/utils.web';
import { extractAppliedFilters } from '../../../utils';

const FilterCheckBox = ({ label, disabled, item, handleClick, appliedFilters }) => {
  const checked = extractAppliedFilters(appliedFilters, item?.facetName)?.includes(item?.id);
  return (
    <StyledCheckboxContainer disabled={disabled}>
      <HiddenCheckbox
        type="checkbox"
        id="checkbox"
        checked={checked}
        onChange={(e) => {
          e.preventDefault();
          handleClick(item?.facetName, item?.id);
        }}
        name={item?.displayName}
      />
      <StyledCheckbox />
      <StyledCheckboxLabel htmlFor="checkbox" fontSize="fs12" fontFamily="secondary">
        {capitalizeFirstWordOfSentence(label)}
      </StyledCheckboxLabel>
    </StyledCheckboxContainer>
  );
};

export default FilterCheckBox;
